import React, { useState, useEffect } from 'react';
import {
    SelectInput,
    TextInput,
    DateInput,
    SimpleForm,
    Edit,
    useNotify,
    useRedirect,
    CardActions,
    ListButton,
    useRecordContext,
    useGetOne
} from 'react-admin';


const cardActionStyle = {
    zIndex: 2,
    display: 'block',
    marginLeft:10
};

const EditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);

const EditHoliday = (props) => {
    const {REACT_APP_API_ENDPOINT} = process.env;
    const [branches, setBranches] = useState([]);
    const notify = useNotify();
    const redirect = useRedirect();
    const record = useRecordContext();

    // Fetch the branches from the server
    const fetchBranches = async () => {
        try {
            const response = await fetch( REACT_APP_API_ENDPOINT+'/appointment/branches');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            // Transform API response to SelectInput format
            const branchChoices = data.result.map(branch => ({
                id: branch.id,
                name: `${branch.location} (${branch.city}, ${branch.state})`
            }));
            return branchChoices;
        } catch (error) {
            return Promise.reject('Failed to fetch branches');
        }
    };

    useEffect(() => {
        fetchBranches()
            .then((branchChoices) => {
                setBranches(branchChoices);
            })
            .catch((error) => {
                notify(error, 'error');
            });
    }, [notify]);

    const handleSuccess = () => {
        notify('Holiday has been successfully updated!', 'success', { autoHideDuration: 3000 });
        redirect('/appointment/holidays');
    };

    const { data, loading, error } = useGetOne('appointment/holidays', props.id );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error loading data</p>;

    return (
        <div style={{backgroundColor:'white', width:'600px'}}>
            <h2 style={{marginLeft:10}}>Edit Holiday</h2>
            <div style={{ width:'600px', margin:'auto'}}>
                <Edit actions={<EditActions />} {...props} undoable={false} onSuccess={handleSuccess}>
                    <SimpleForm>
                        {/* Branch Dropdown */}
                        <SelectInput
                            source="branch_id"
                            label="Select Branch"
                            choices={branches}
                            optionText="name"
                            optionValue="id"
                            fullWidth
                            defaultValue={record?.branch_id} // Pre-fill with the existing branch
                        />

                        {/* Holiday Date Field */}
                        <DateInput
                            source="holiday_date"
                            label="Holiday Date"
                            fullWidth
                            defaultValue={record?.holiday_date} // Pre-fill with existing date
                        />

                        {/* Holiday Description Field */}
                        <TextInput
                            source="description"
                            label="Description"
                            multiline
                            fullWidth
                            defaultValue={record?.description} // Pre-fill with the existing description
                        />
                    </SimpleForm>
                </Edit>
            </div>
        </div>
    );
};

export default EditHoliday;
